import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-counter-badge',
  templateUrl: './counter-badge.component.html',
  styleUrl: './counter-badge.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CounterBadgeComponent {
  @Input() count: number = 0;
}
